if (!customElements.get('cyf-product-details')) {
  customElements.define('cyf-product-details', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const description = this.querySelector('[data-product-description]');
      if (!description) return;
      description.querySelectorAll('table').forEach((table) => {
        if (table.parentElement.classList.contains('cyf-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'cyf-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', this.dataset.tableLabel);
        table.before(wrapper);
        wrapper.append(table);
      });
      const productInfo = this.closest('product-info');
      productInfo?.querySelectorAll('[data-cyf-size-guide]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const table = description.querySelector('table');
          const details = description.closest('details');
          if (!table || !details) return;
          event.preventDefault();
          details.open = true;
          // Keep the original unit and fit context visible above the table.
          const headings = [...description.querySelectorAll('h2,h3,h4,p')].filter((element) =>
            (element.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING) &&
            /size chart|size guide|sizing|尺寸|尺码|尺碼|测量|測量/i.test(element.textContent)
          );
          const target = headings.at(-1) || table.parentElement;
          table.parentElement.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
